// Curated themed background photos (Unsplash CDN, verified reachable & labeled).
// Used as an optional invitation background to complement the SVG ornaments.
export const BACKGROUNDS = [
  { id: "none", label: "Tanpa Foto Latar", url: "" },
  { id: "flowers", label: "Bunga / Taman", url: "https://images.unsplash.com/photo-1490750967868-88aa4486c946?w=1400&q=60&auto=format&fit=crop" },
  { id: "beach", label: "Pantai Senja", url: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1400&q=60&auto=format&fit=crop" },
  { id: "mosque", label: "Masjid", url: "https://images.unsplash.com/photo-1519817650390-64a93db51149?w=1400&q=60&auto=format&fit=crop" },
  { id: "nature", label: "Alam / Perbukitan", url: "https://images.unsplash.com/photo-1470252649378-9c29740c9fa8?w=1400&q=60&auto=format&fit=crop" },
  { id: "lights", label: "Lampu Pesta (Romantis)", url: "https://images.unsplash.com/photo-1464047736614-af63643285bf?w=1400&q=60&auto=format&fit=crop" },
];

export function getBackground(id) {
  return BACKGROUNDS.find((b) => b.id === id) || BACKGROUNDS[0];
}

export function getBackgroundUrl(id) {
  const b = BACKGROUNDS.find((x) => x.id === id);
  return b ? b.url : "";
}
